var map = {
	"./de/impressum.mdx": [
		46897,
		6897
	],
	"./de/index.mdx": [
		62095,
		2095
	],
	"./de/rechtliche-grundlagen.mdx": [
		60819,
		819
	],
	"./en/imprint.mdx": [
		19621,
		9621
	],
	"./en/index.mdx": [
		54201,
		4201
	],
	"./en/legal-framework.mdx": [
		83767,
		3767
	],
	"./fr/cadre-juridique.mdx": [
		32148,
		2148
	],
	"./fr/impressum.mdx": [
		70249,
		249
	],
	"./fr/index.mdx": [
		42586,
		2586
	],
	"./it/colophon.mdx": [
		3865,
		3865
	],
	"./it/index.mdx": [
		73377,
		3377
	],
	"./it/quadro-giuridico.mdx": [
		65961,
		5961
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 51058;
module.exports = webpackAsyncContext;